window.config = {
     apiUrl: '/api',
     //apiUrl: 'http://sharp-proxy.local/api',
}
